<template>
  <span>
  <a @click="toggleDoctor"
     :title="object.blocked == 0 ? $t('block') : $t('activate')"
     v-b-tooltip.hover
     class="data-table-action">
    <BlockSvg v-if="object.blocked == 0"/>
    <ActivateSvg class="svg-light" v-if="object.blocked == 1"/>
    <span class="action-button-mob-title">{{ object.blocked == 0 ? $t('block') : $t('activate') }}</span>
  </a>
    <a @click="editSchedule"
       v-if="rights.includes('administrator_schedule_edit')"
       :title="$t('schedule')"
       v-b-tooltip.hover
       class="data-table-action">
      <ClockSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('schedule') }}</span>
    </a>
    </span>
</template>

<script setup>

import BlockSvg from '@/assets/svg-vue/general/block.svg'
import ActivateSvg from '@/assets/svg-vue/form/tick.svg'
import { EloquentService } from "@/services/api/eloquent.api.service"
import { doctorAdapter } from '@/adapters/staff/doctor'
import ClockSvg from "@/assets/svg-vue/calendar/clock2.svg.vue"
import { useStore} from "vuex"
import {computed, getCurrentInstance, nextTick} from "vue"
import {appendFormdata, copyObject} from "@/extensions/prototypes/prototypes"

const props = defineProps({
  object: {
    type: Object
  }
})

const store = useStore()
const instance = (getCurrentInstance())

const rights = computed(() => store.state.auth.rights)

const toggleDoctor = () => {
  let data = doctorAdapter(props.object)
  delete data.full
  data.blocked = Number(props.object?.blocked) === 1 ? 0 : 1
  const formData = appendFormdata(new FormData(), data)
  EloquentService.update('administrator', props.object.id, formData).then(() => {
    store.commit('incrementDataTableCounter')
  })
}

const editSchedule = async () => {
  const bvModal = instance?.ctx?._bv__modal
  store.commit('setDoctor', copyObject(props.object))
  await nextTick()
  bvModal.show('doctor-schedule-modal')
}
</script>
